'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

interface RowProps extends PropsWithChildren {
  isOdd?: boolean
}

const Row: React.FC<RowProps> = ({ isOdd, ...props }) => {
  return (
    <tr {...props} className={`${styles.row} ${isOdd ? styles.odd : ''}`} />
  )
}

export default Row
